import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from 'styled-components';
import { fonts, colors } from './mixins.js';

const StyledTab = styled(Tab)`
  && {
    ${fonts.normalText()};
    text-transform:none;
     margin: 0;
    margin-right: 24px; 
  
    min-width:auto;
    max-width:fit-content;
  height:auto !important;
    min-height: auto !important;
   padding:0 2px 8px 2px;
    &.Mui-selected {
     color: ${colors.darkText};
    }
  }
`;

const StyledTabList = styled(TabList)`
    height:auto !important;
    min-height: auto !important;
  .MuiTabs-indicator {
    background-color: ${colors.primary};
    height: 4px;
    border-radius: 24px;
  }
`;

const StyledTabPanel = styled(TabPanel)`
  width:100%;
  padding:0 !important;
 padding-top: ${({ hideTabs, isFirst, hasLabel, hasProducts }) =>
        hideTabs ? "0px" : (isFirst && hasLabel && !hasProducts ? "8px" : "24px")
} !important;
`;
export default function TabbedContent({ tabs, tabPanels, hasLabel = false, hideTabs = false, hasProducts }) {
    const [value, setValue] = React.useState('0');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{width: '100%', 
          '@media (max-width: 1000px)': { marginTop: '8px' }}}>
            <TabContext value={value}>
                {!hideTabs && <Box >
                    <StyledTabList onChange={handleChange}>
                        {tabs.map((tab, index) => (
                            <StyledTab key={index}
                                label={tab}
                                value={String(index)}
                                name={`tab${index}`}
                                disableRipple />
                        ))}
                    </StyledTabList>
                </Box>}
               {tabPanels.map((panel, index) => (
                   <StyledTabPanel key={index} value={String(index)} hideTabs={hideTabs} isFirst={index === 0} hasLabel={hasLabel} hasProducts={hasProducts}>
                        {panel}
                    </StyledTabPanel>
                ))}
            </TabContext>
        </Box>
    );
}
